module.exports = __webpack_public_path__ + "static/vmware_23.1f75557a.jpg";